import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { entrarDeNovoSeSessaoVencida } from './angularjs-app/services/auth/keycloak/keycloak.util';
import { initDatadogRum } from './datadog-rum';
import { environment } from './environments/environment';

initDatadogRum();

if (environment.production) {
  enableProdMode();
}

// An expired Keycloak session this tab cannot renew goes back to Keycloak before the app starts:
// booting with it would load the page only to get 401 from every call.
if (!entrarDeNovoSeSessaoVencida()) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
}

// Registrar Service Worker se habilitado
if (environment.enableSW && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/ngsw-worker.js')
      .catch(error => {
        console.error('[SW] Erro ao registrar Service Worker:', error);
      });
  });
}
